module.exports = __webpack_public_path__ + "img/university_14.6aa3cfd0.png";